import { Injectable, Provider } from '@angular/core';

import { SpeiAttemptsByNode } from '@app/domain/models/spei/spei-attempts-by-node';
import {
  SPEI_ORDER_ATTEMPTS_CAPACITY,
  SpeiIndividualAttemptKeys,
} from '@app/domain/models/spei/spei-order-attempt-memory';
import { SpeiOrderAttemptMemory } from '@app/domain/ports/spei/spei-order-attempt-memory';

/**
 * Los intentos de orden SPEI de Suite, por origen, en la memoria de la PESTAÑA
 * (feature 125; el espejo de `InMemoryCardsSpeiAttemptMemory`).
 *
 * - Singleton raíz: sobrevive a salir de la pantalla y volver (el desenlace
 *   desconocido manda a revisar movimientos o el historial, otra ruta), así que
 *   reenviar el MISMO cuerpo reusa la llave y banca responde replay.
 * - ⚠️ Solo heap: nada va a `sessionStorage`, `localStorage`, el borrador de la
 *   masiva, la URL ni a logs. Recargar la pestaña la pierde (aceptado).
 * - Se vacía en `LogoutService.forgetTabMemory()` (cierre de sesión e inicio de login).
 */
@Injectable({ providedIn: 'root' })
export class InMemorySpeiOrderAttemptMemory extends SpeiOrderAttemptMemory {
  readonly orders = new SpeiAttemptsByNode<SpeiIndividualAttemptKeys>(SPEI_ORDER_ATTEMPTS_CAPACITY);
  readonly batches = new SpeiAttemptsByNode<string>(SPEI_ORDER_ATTEMPTS_CAPACITY);

  clear(): void {
    this.orders.clear();
    this.batches.clear();
  }
}

/**
 * El enlace del puerto con el singleton de la pestaña. Va SOLO en la raíz
 * (`app.config.ts`, y en los TestBed como raíz). ⚠️ Nunca en `providers` de una página.
 */
export function provideSpeiOrderAttemptMemory(): Provider[] {
  return [{ provide: SpeiOrderAttemptMemory, useExisting: InMemorySpeiOrderAttemptMemory }];
}
